
import React from 'react';
import { TemplateCard } from './TemplateCard';
import { ScrollArea } from '@/components/ui/scroll-area';

interface Template {
  id: string;
  title: string;
  description: string | null;
  hebrew_title: string | null;
  hebrew_description: string | null;
}

interface TemplateListProps {
  templates: Template[];
  isLoading: boolean;
  onEdit: (template: Template) => void;
  onDelete: (templateId: string) => void;
}

export const TemplateList = ({ templates, isLoading, onEdit, onDelete }: TemplateListProps) => {
  return (
    <ScrollArea className="h-[60vh] pr-4">
      {isLoading ? (
        <div className="text-center py-4">Loading templates...</div>
      ) : templates.length === 0 ? (
        <div className="text-center py-4 text-gray-500">
          No custom templates available
        </div>
      ) : (
        <div className="space-y-4">
          {templates.map((template) => (
            <TemplateCard
              key={template.id}
              template={template}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </ScrollArea>
  );
};
